module.exports = __webpack_public_path__ + "static/globalwar_clud-df6c72f2499525059f7a8a3084e87bb7.png";